import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-2 container mx-auto px-2 md:px-0 mt-10" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["disabled"]
const _hoisted_15 = ["disabled"]
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["disabled"]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _cache[17] || (_cache[17] = _createElementVNode("a", {
      href: "/",
      class: "text-white bg-black hover:bg-gray-800 text-center rounded-xl cursor-pointer py-2"
    }, "หน้าแรก", -1 /* HOISTED */)),
    _cache[18] || (_cache[18] = _createElementVNode("a", {
      href: "/slot",
      class: "text-white bg-black hover:bg-gray-800 text-center rounded-xl cursor-pointer py-2"
    }, "เกมทั้งหมด", -1 /* HOISTED */)),
    _createElementVNode("button", {
      type: "button",
      onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.btnClickRegister && _ctx.btnClickRegister(...args))),
      disabled: _ctx.loggedIn,
      class: "text-white bg-black enabled:hover:bg-gray-800 enabled:cursor-pointer disabled:opacity-75 disabled:cursor-not-allowed rounded-xl py-2"
    }, "สมัครสมาชิก", 8 /* PROPS */, _hoisted_2),
    _createElementVNode("button", {
      type: "button",
      onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.btnClickLogin && _ctx.btnClickLogin(...args))),
      disabled: _ctx.loggedIn,
      class: "text-white bg-black enabled:hover:bg-gray-800 enabled:cursor-pointer disabled:opacity-75 disabled:cursor-not-allowed rounded-xl py-2"
    }, "เข้าสู่ระบบ", 8 /* PROPS */, _hoisted_3),
    _createElementVNode("button", {
      type: "button",
      onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.btnClickForgotPassword && _ctx.btnClickForgotPassword(...args))),
      disabled: _ctx.loggedIn,
      class: "text-white bg-black enabled:hover:bg-gray-800 enabled:cursor-pointer disabled:opacity-75 disabled:cursor-not-allowed rounded-xl py-2"
    }, "ลืมรหัสผ่าน", 8 /* PROPS */, _hoisted_4),
    _createElementVNode("button", {
      type: "button",
      onClick: _cache[3] || (_cache[3] = (...args) => (_ctx.btnClickProfile && _ctx.btnClickProfile(...args))),
      disabled: !_ctx.loggedIn,
      class: "text-white bg-black enabled:hover:bg-gray-800 enabled:cursor-pointer disabled:opacity-75 disabled:cursor-not-allowed rounded-xl py-2"
    }, "โปรไฟล์", 8 /* PROPS */, _hoisted_5),
    _createElementVNode("button", {
      type: "button",
      onClick: _cache[4] || (_cache[4] = (...args) => (_ctx.btnClickChangePassword && _ctx.btnClickChangePassword(...args))),
      disabled: !_ctx.loggedIn,
      class: "text-white bg-black enabled:hover:bg-gray-800 enabled:cursor-pointer disabled:opacity-75 disabled:cursor-not-allowed rounded-xl py-2"
    }, "เปลี่ยนรหัสผ่าน", 8 /* PROPS */, _hoisted_6),
    _createElementVNode("button", {
      type: "button",
      onClick: _cache[5] || (_cache[5] = (...args) => (_ctx.btnClickLogout && _ctx.btnClickLogout(...args))),
      disabled: !_ctx.loggedIn,
      class: "text-white bg-black enabled:hover:bg-gray-800 enabled:cursor-pointer disabled:opacity-75 disabled:cursor-not-allowed rounded-xl py-2"
    }, "ออกจากระบบ", 8 /* PROPS */, _hoisted_7),
    _createElementVNode("button", {
      type: "button",
      onClick: _cache[6] || (_cache[6] = (...args) => (_ctx.btnClickWalletWithdraw && _ctx.btnClickWalletWithdraw(...args))),
      disabled: !_ctx.loggedIn,
      class: "text-white bg-black enabled:hover:bg-gray-800 enabled:cursor-pointer disabled:opacity-75 disabled:cursor-not-allowed rounded-xl py-2"
    }, "ถอน", 8 /* PROPS */, _hoisted_8),
    _createElementVNode("button", {
      type: "button",
      onClick: _cache[7] || (_cache[7] = (...args) => (_ctx.btnClickAffiliateLink && _ctx.btnClickAffiliateLink(...args))),
      disabled: !_ctx.loggedIn,
      class: "text-white bg-black enabled:hover:bg-gray-800 enabled:cursor-pointer disabled:opacity-75 disabled:cursor-not-allowed rounded-xl py-2"
    }, "ลิ้งค์แนะนำเพื่อน", 8 /* PROPS */, _hoisted_9),
    _createElementVNode("button", {
      type: "button",
      onClick: _cache[8] || (_cache[8] = (...args) => (_ctx.btnClickAffiliateHistory && _ctx.btnClickAffiliateHistory(...args))),
      disabled: !_ctx.loggedIn,
      class: "text-white bg-black enabled:hover:bg-gray-800 enabled:cursor-pointer disabled:opacity-75 disabled:cursor-not-allowed rounded-xl py-2"
    }, "ประวัติแนะนำเพื่อน", 8 /* PROPS */, _hoisted_10),
    _createElementVNode("button", {
      type: "button",
      onClick: _cache[9] || (_cache[9] = (...args) => (_ctx.btnClickAffiliateReport && _ctx.btnClickAffiliateReport(...args))),
      disabled: !_ctx.loggedIn,
      class: "text-white bg-black enabled:hover:bg-gray-800 enabled:cursor-pointer disabled:opacity-75 disabled:cursor-not-allowed rounded-xl py-2"
    }, "รายงานแนะนำเพื่อน", 8 /* PROPS */, _hoisted_11),
    _createElementVNode("button", {
      type: "button",
      onClick: _cache[10] || (_cache[10] = (...args) => (_ctx.btnClickAffiliateDownline && _ctx.btnClickAffiliateDownline(...args))),
      disabled: !_ctx.loggedIn,
      class: "text-white bg-black enabled:hover:bg-gray-800 enabled:cursor-pointer disabled:opacity-75 disabled:cursor-not-allowed rounded-xl py-2"
    }, "ดาวน์ไลน์แนะนำเพื่อน", 8 /* PROPS */, _hoisted_12),
    _createElementVNode("button", {
      type: "button",
      onClick: _cache[11] || (_cache[11] = (...args) => (_ctx.btnClickPromotionList && _ctx.btnClickPromotionList(...args))),
      disabled: !_ctx.loggedIn,
      class: "text-white bg-black enabled:hover:bg-gray-800 enabled:cursor-pointer disabled:opacity-75 disabled:cursor-not-allowed rounded-xl py-2"
    }, "โปรโมชั่น", 8 /* PROPS */, _hoisted_13),
    _createElementVNode("button", {
      type: "button",
      onClick: _cache[12] || (_cache[12] = (...args) => (_ctx.btnClickPromotionBonus && _ctx.btnClickPromotionBonus(...args))),
      disabled: !_ctx.loggedIn,
      class: "text-white bg-black enabled:hover:bg-gray-800 enabled:cursor-pointer disabled:opacity-75 disabled:cursor-not-allowed rounded-xl py-2"
    }, "โบนัส", 8 /* PROPS */, _hoisted_14),
    _createElementVNode("button", {
      type: "button",
      onClick: _cache[13] || (_cache[13] = (...args) => (_ctx.btnClickPromotionCoupon && _ctx.btnClickPromotionCoupon(...args))),
      disabled: !_ctx.loggedIn,
      class: "text-white bg-black enabled:hover:bg-gray-800 enabled:cursor-pointer disabled:opacity-75 disabled:cursor-not-allowed rounded-xl py-2"
    }, "คูปอง", 8 /* PROPS */, _hoisted_15),
    _createElementVNode("button", {
      type: "button",
      onClick: _cache[14] || (_cache[14] = (...args) => (_ctx.btnClickPromotionSetting && _ctx.btnClickPromotionSetting(...args))),
      disabled: !_ctx.loggedIn,
      class: "text-white bg-black enabled:hover:bg-gray-800 enabled:cursor-pointer disabled:opacity-75 disabled:cursor-not-allowed rounded-xl py-2"
    }, "ปรับแต่งโปรโมชั่น", 8 /* PROPS */, _hoisted_16),
    _createElementVNode("button", {
      type: "button",
      onClick: _cache[15] || (_cache[15] = (...args) => (_ctx.btnClickEntertainment && _ctx.btnClickEntertainment(...args))),
      disabled: !_ctx.loggedIn,
      class: "text-white bg-black enabled:hover:bg-gray-800 enabled:cursor-pointer disabled:opacity-75 disabled:cursor-not-allowed rounded-xl py-2"
    }, "ความบันเทิง", 8 /* PROPS */, _hoisted_17),
    _createElementVNode("button", {
      type: "button",
      onClick: _cache[16] || (_cache[16] = (...args) => (_ctx.btnClickContact && _ctx.btnClickContact(...args))),
      class: "text-white bg-black enabled:hover:bg-gray-800 enabled:cursor-pointer disabled:opacity-75 disabled:cursor-not-allowed rounded-xl py-2"
    }, "ติดต่อ")
  ]))
}